<template>
  <modal-form-helper :data="{...mdldata, title:'Opportunity'}" :form="post">
    <template #body>
      <div ref="field_defs" class="d-none">
        
        <div ref="field_company">
          <form-select2
              :required="false"
              name="company"
              label="Company"
              :form="post"
              v-model="post.company"
              :options="drdata.companies"
              :config="search_conf_company"
              :classes="['form-select-solid form-select-sm']"
              debounce="true"
              :debounce-settings="{url: genUrl('opportunity'), route_name: 'crm_opportunity_details', param: 'company', label: 'title'}"
          />
        </div>
        <div ref="field_pipeline">
          <form-select2
              :required="false"
              name="pipeline"
              label="Pipeline"
              :form="post"
              @change="onChangePiplineStage($event)"
              v-model="post.pipeline"
              :options="pipelines"
              :config="{
                id: 'id',
                label: 'name',
                searchable: false,
                clearable: false,
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_pipeline_stage">
          <form-select2
              :required="false"
              name="pipeline_stage"
              label="Pipeline stage"
              :form="post"
              v-model="post.pipeline_stage"
              :options="pipeline_stages"
              :config="search_conf_pstage"
              :classes="['form-select-solid form-select-sm']"
          />
        </div>
        <div ref="field_lead_type">
          <form-select2
              :required="false"
              name="lead_types"
              label="Lead types"
              :form="post"
              v-model="post.lead_type"
              :options="lead_types"
              :config="{
          id: 'id',
          label: 'title',
          searchable: false,
          clearable: false,
        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_title">
          <form-input :required="false" v-model="post.title" :form="post" name="title" label="Title"/>
        </div>
        <div ref="field_pitch_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Pitch Date</slot>
          </label>
          <date-picker v-model="post.pitch_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="pitch_date"></has-error>
        </div>
        <div ref="field_expected_exit_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Expected Exit Date</slot>
          </label>
          <date-picker v-model="post.expected_exit_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="expected_exit_date"></has-error>
        </div>

        <div ref="field_first_name">
          <div v-if="contactLocked" style="height: 20px;">
            <!--            <button type="button" class="btn btn-sm">Existing contact selected</button>-->
          </div>
          <label class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">First Name</label>
          <autocomplete
              :key="acKey"
              ref="firstNameAutoComplete"
              :disabled="!post.company"
              :default-value="post.first_name"
              :search="searchDebounced"
              placeholder=""
              aria-label="First Name"
              :get-result-value="getResultValue"
              @submit="handleSubmit"
              :submitOnEnter="true"
              :debounce-time="500"
          ></autocomplete>
          <has-error v-if="post" :form="post" field="first_name"></has-error>
        </div>
        <div ref="field_last_name">
          <div v-if="contactLocked" style="height: 20px;">
          </div>
          <form-input :required="false"
                      :disabled="!post.company"
                      v-model="post.last_name"
                      @input="(val) => contactLocked = false"
                      :form="post" name="contact" label="Last Name"/>
          <has-error v-if="post" :form="post" field="last_name"></has-error>
        </div>
        <div ref="field_internal_introducers">
          <form-select2
              :required="false"
              name="internal_introducers"
              label="Introducers"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.internal_introducers"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_team_members">
          <form-select2
              :required="false"
              name="team_members"
              label="Team Members"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.team_members"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_owner">
          <form-select2
              :required="false"
              name="owner"
              label="Owner"
              placeholder="Select One"
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.owner"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: false,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <div ref="field_opportunity_status">
          <form-select2
              :required="false"
              name="opportunity_status"
              label="Opportunity Status"
              :form="post"
              v-model="post.opportunity_status"
              :options="status"
              :config="{
                  id: 'id',
                  label: 'title',
                  searchable: false,
                  clearable: false,
                }"
              :classes="['form-select-solid']"
          />
        </div>

        <!--Custom fields-->
        <div v-for="field in fields.custom_fields">
          <div :ref="`field_${field.field_key}`">
            <div v-if="field.field_type==='text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='long_text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='multiple_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label',
                              multiple: true,
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='single_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label'
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='date'" :id="`field_${field.field_key}`">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label d-flex">
                {{ field.title }}
              </label>
              <date-picker
                          :value="post[field.field_key]"
                          @input="(val) => setDateForce(field.field_key, val)"
                         :typeable="false"
                           input-class="form-control form-control-sm form-control-solid mb-3 w-100"
                           format="DD-MM-YYYY"/>
            </div>
            <has-error :form="post" :field="field.field_key"></has-error>
          </div>
        </div>
      </div>

      <div ref="fields_rend">
        <div v-for="section in sections">
          <h4 v-show="section.title_show">{{ section.title }}</h4>
          <div class="row" v-for="(col, colIndex) in Array.from({length: section.max_rows})">
            <div class="col-md-6" v-for="(dir, dirIndex) in section.directions">
              <div v-if="section.fields[dirIndex][colIndex]"
                   :ref="`rend_field_${section.fields[dirIndex][colIndex].field}`"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
import get_custom_fields from './company/get_custom_fields'
import UserSelector from "@cc/includes/UserSelector.vue";

export default {
  components: {UserSelector},
  mixins: [cm, get_custom_fields],
  props: {
    source: '',
    url_key: {
      default: 'opportunity'
    },
    project: {default: null},
    asModal: {default: true},
    company: null,
    companies: [],
    // customFields: {default: []},
    fetchOpportunityExist:{
      type: Function,
      required: false
    }
  },
  data() {
    return {
      form_category: 'opportunity',
      id: null,
      isModal: true,

      searchingName: false,
      nameDuplicates: [],

      acKey: 'ac_key_1',
      contactLocked: null,

      drdata: {
        companies: [],
        country_codes: [],
        titles: [],
        ownerships: [],
        contacts: [],
        project: null,
      },
      // fields: this.customFields,
      first_name_opts: [],
      pipelines: [],
      pipeline_stages: [],
      lead_types: [],
      users: [this.$user],
      post: Form.make({
        first_name: '',
        last_name: '',

        company: '',
        title: '',
        pitch_date: null,
        expected_exit_date: null,
        pipeline: '',
        lead_type: '',
        pipeline_stage: '',
        internal_introducers: [],
        team_members: [],
        owner: this.$user.id,
        opportunity_status:'',
      }),
      test:this.$user,
      status:[],
    };
  },
  computed: {
    first_name_ajax_config() {
      return {
        id: 'first_name',
        label: 'name',
        raw: {
          tags: true
        },
        ajax: {
          paginated: false,
          url: this.genUrl('contact', null, 'search'),
          term: 'query',
          params: {company: this.post.company},
        }
      }
    },
    search_conf_company() {
      return {
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null, 'search'),
          term: 'name',
        }
      }
    },
    search_conf_pstage() {
      return {
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('pipeline_stages'),
          term: 'name',
          params: {pipeline: this.post.pipeline}
        }
      }
    },
  },
  mounted() {
    if(this.company && this.companies){
      this.post.company = this.company
      this.drdata.companies = [...this.companies]
    }

    axios.get(this.genUrl('form_settings', null, 'get_form_data'))
        .then(({data}) => {
            console.log(data)
            this.pipelines = data.pipelines;
            this.lead_types = data.lead_types;
            let default_pipelines = (data.pipelines).find((el) => (el.name.toLowerCase()).trim() == "origination team - prospecting")

            if(default_pipelines){
              this.post.pipeline = default_pipelines?default_pipelines.id:''
              this.getPipelinesStages(default_pipelines.id)
            }
            

        })

    let url = this.genUrl('form_settings', null, 'custom_fields')
    this.getCustomFields(url)
    // this.fetchRenderFields(url)
    this.fetchOpportunityStatus()
    
    
  },
  methods: {
    onChangePiplineStage(event){
      this.getPipelinesStages(event)
    },
    getPipelinesStages(pipeline_id){
      axios.get(this.genUrl('pipeline_stages'),{params: {pipeline: pipeline_id}})
      .then( ({data}) => {
        console.log(data.data)
          let default_pipeline_stage = (data.data).find((el) => (el.name.toLowerCase()).trim() == "qualified")
          this.pipeline_stages = data.data
          this.post.pipeline_stage = default_pipeline_stage ? default_pipeline_stage.id : ''
          if(this.company_id){
              this.post.company = this.company_id
            }
      })
    },
    postCreate(data){
      if(this.source == 'quick_menu'){
        this.close()
        return
      }

      if(this.source == 'overview'){
        this.fetchOpportunityExist()
        this.close()
        return
      }

      return this.$router.push({name: 'crm_opportunity_details', params: {id: data.id}})
    },
    getResultValue(result) {
      console.log(result)
      this.contactLocked = false
      return result.name
    },
    handleSubmit(result) {
      // debugger
      this.contactLocked = true
      this.post.first_name = result.first_name
      this.post.last_name = result.last_name
      this.acKey = _.random(true)
      // this.$nextTick(() => {
      //   try{
      //     this.$refs.firstNameAutoComplete.$refs.input.focus()
      //   }catch (e){
      //     console.error("CANT_FOCUS_AUTOCOMPLETE_XR")
      //   }
      // })
      console.log(result)
    },
    searchDebounced(input) {
      this.post.first_name = input

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('contact', null, 'search'), {
          params: {query: input, company: this.post.company}
        })
            .then(({data}) => {
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },

    extraData() {
      return {
        pitch_date: this.momentMixin(this.post.pitch_date, 'YYYY-MM-DD'),
        expected_exit_date: this.momentMixin(this.post.expected_exit_date, 'YYYY-MM-DD'),
      }
    },
    edit() {
      this.startCompLoading()
      axios.get(this.genUrl(this.url_key, this.id, 'post'))
          .then(({data}) => {
            const contact = data.contacts[0]
            console.log(contact)
            this.post.update({
              ...this.post,
              ...data,
              ...contact
            })
          })
          .catch(err => console.error(err))
          .finally(() => this.endCompLoading())
    },

    fetchOpportunityStatus(){
      this.startCompLoading()
      axios.get(this.genUrl('opportunity_status', null, 'get'))
          .then(({data}) => {
            console.log(data)
            this.status = data.data

            if(this.status.length){
              //default status active
              let default_status = (data.data).find((el) => (el.title.toLowerCase()).trim() == "active")
              this.post.opportunity_status = default_status?default_status.id:''
            }

            this.endCompLoading()
          })
          .catch(err => {
            this.toastLaraValidation(err)
            this.endCompLoading()
          })
    }
  },
}
</script>

<style scoped>
input.autocomplete-input {
  font-size: unset;
  background-image: unset;
  padding: 0.55rem 0.77rem;
  border-radius: 0.325rem;
}
</style>